import { photoblog_snippet_create_url } from 'mk/urls/functions';
import * as xhr from 'mk/xhr';

export function createSnippet(apiAuth, messageUrls) {
    return xhr.post(apiAuth, photoblog_snippet_create_url(), {urls: messageUrls});
}
